import React from 'react';
import classNames from 'classnames';
import { Loader } from 'ncoded-component-library';

import './LoadingCard.styles.scss';

type LoadingCardProps = {
  className?: string;
  isLoading?: boolean;
};

const LoadingCard: React.FC<LoadingCardProps> = (props) => {
  const { children, className, isLoading } = props;

  const classes = classNames('loading-card', className);

  return <div className={classes}>{isLoading ? <Loader /> : children}</div>;
};

export default LoadingCard;
